<template>
  <div class="camera-monitor">
    <v-card
      class="pt-2 px-2 d-flex"
      :width="monitorWidth"
      height="40px"
      tile
      flat
      color="#F5F5F5"
    >
      <div class="caption font-weight-bold">カメラ一覧</div>
      <v-btn class="ml-auto mr-2" x-small icon @click="close()">
        <v-icon x-small>
          mdi-close
        </v-icon>
      </v-btn>
    </v-card>

    <v-card
      :width="monitorWidth"
      class="overflow-y-auto"
      style="background-color: #f5f5f5;"
      tile
      flat
      height="calc(100vh - 40px)"
    >
      <v-card
        v-for="key in Object.keys(dataset)"
        :key="key"
        tile
        flat
        color="#F5F5F5"
      >
        <div class="caption font-weight-bold px-2">{{ dataset[key].name }}</div>
        <v-card
          width="100%"
          class="wrap-container overflow-y-auto d-flex align-content-start flex-wrap"
          tile
          flat
          color="#F5F5F5"
        >
          <v-card
            v-for="station in dataset[key].stations"
            :key="station.id"
            class="px-2 py-1"
            :width="cardWidth"
            tile
            flat
            color="#F5F5F5"
          >
            <div class="caption station-area" @click="moveStation(station)">
              <v-card height="46" flat tile>
                <div>{{ station.name }}</div>
                <div>{{ station.address }}</div>
                <!-- <div>{{ station.lat.toFixed(6) }}, {{ station.lng.toFixed(6) }}</div> -->
              </v-card>
              <v-img
                v-if="station.url"
                width="220"
                height="120"
                :src="station.url"
              />
              <v-img
                v-else
                width="220"
                height="120"
                :src="require('@/assets/images/camera-none.jpg')"
                contain
              />
              <div style="height: 16px">{{ station.date }}</div>
            </div>
          </v-card>
        </v-card>
      </v-card>
    </v-card>

    <v-dialog
      content-class="camera-dialog"
      v-model="dialog"
      max-width="1100"
      @click="dialog = false"
      style="z-index: 1003"
    >
      <v-img :src="targetUrl" contain @click="dialog = false" />
    </v-dialog>
  </div>
</template>
<script>
import * as api from "../utils/api";
import L from "leaflet";
import moment from "moment";
import { ROAD_CAMERAS } from "../utils/common";

export default {
  name: "CameraMonitor",
  components: {},
  data() {
    return {
      cardWidth: 250,
      windowWidth: window.innerWidth,
      baseStations: [],
      targetUrl: "",
      dialog: false,
      dataset: {
        river: {
          name: "河川カメラ",
          stations: []
        },
        road: {
          name: "道路カメラ",
          stations: []
        }
      }
    };
  },

  computed: {
    cameras() {
      const observatories = this.$store.getters.observatories;
      const cameras = observatories.filter(obs => obs.type === 30);
      cameras.sort((a, b) => {
        // 緯度降順
        if (a.lat > b.lat) return -1;
        if (a.lat < b.lat) return 1;
        return 0;
      });
      return cameras;
    },
    rowPanelNum() {
      const num = Math.floor((this.windowWidth - 500) / this.cardWidth);
      if (num < 1) {
        return 1;
      } else {
        return num;
      }
    },
    monitorWidth() {
      return this.cardWidth * this.rowPanelNum + 5;
    },
    map() {
      return this.$store.getters.leafletMap;
    },
    baseDate() {
      return this.$store.getters.baseDate;
    }
  },

  watch: {
    baseDate(newval, oldval) {
      if (!newval.isSame(oldval)) {
        this.sync();
      }
    },
    rowPanelNum(newval, oldval) {
      if (newval !== oldval) {
        this.refreshStations();
      }
    }
  },

  created() {
    window.addEventListener("resize", this.resizeWindow);
    this.sync();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.resizeWindow);
  },

  mounted() {
    //
  },

  methods: {
    resizeWindow() {
      this.windowWidth = window.innerWidth;
    },
    close() {
      this.$store.commit("SET_IS_CAMERA_MONITOR", false);
    },
    moveStation(station) {
      this.map.panTo(new L.LatLng(station.lat, station.lng));
      if (this.map.getZoom() < 14) {
        setTimeout(() => {
          this.map.setZoom(14);
        }, 500);
      }
      if (station.url) {
        this.targetUrl = station.url;
        this.dialog = true;
      }
    },
    refreshStationsByKind(kind) {
      let stations = [];
      if (kind === "river") {
        stations = this.baseStations.filter(station => {
          return !ROAD_CAMERAS.includes(station.id);
        });
      } else {
        stations = this.baseStations.filter(station => {
          return ROAD_CAMERAS.includes(station.id);
        });
      }
      let response = [];
      let targets = [];
      stations.forEach(station => {
        targets.push(station);
        targets.sort((a, b) => {
          // 経度昇順
          if (a.lng > b.lng) return 1;
          if (a.lng < b.lng) return -1;
          return 0;
        });
        if (targets.length >= this.rowPanelNum) {
          response = response.concat(targets);
          targets = [];
        }
      });
      if (targets.length > 0) {
        response = response.concat(targets);
      }
      return response;
    },
    refreshStations() {
      this.dataset.river.stations = this.refreshStationsByKind("river");
      this.dataset.road.stations = this.refreshStationsByKind("road");
    },
    async sync() {
      this.dataset.river.stations = [];
      this.dataset.road.stations = [];
      this.baseStations = [];
      const processes = this.cameras.map(target => {
        return (async () => {
          const params = {
            date: this.baseDate.format("YYYY/MM/DD HH:mm"),
            id: target.id,
            type: 30
          };
          if (target.bucket) {
            params["bucket"] = target.bucket;
          }
          if (target.prefix) {
            params["prefix"] = target.prefix;
          }
          const row = { ...target };
          row.date = "";
          row.url = "";
          this.baseStations.push(row);
          const response = await api.get("/observatories/data", params);
          if (response !== null && response.timeSeries) {
            const cameraData = response.timeSeries;
            if (cameraData && cameraData.length > 0) {
              const latest = cameraData[cameraData.length - 1];
              row.date = moment
                .utc(latest.date)
                .local()
                .format("YYYY年M月D日 HH時mm分");
              row.url = latest.url;
            }
          }
        })();
      });
      await Promise.all(processes);
      this.refreshStations();
    }
  }
};
</script>

<style lang="scss" scoped>
.station-area {
  background-color: white;
  padding: 8px 14px;
  cursor: pointer;
  border: 1px solid rgb(228, 228, 228);
}
.camera-dialog {
  box-shadow: none !important;
}
</style>
